import React from 'react';
import PricingPlans from '../components/Pricing-plans/PricingPlans';
import HeroSection from '../components/HeroSection/HeroSection';
import Services from '../components/Services/Services';
import Navbar from '../components/Navbar/Navbar';
import About from '../components/AboutUs/About';
import TabsSection from '../components/Tabs/Tabs';
import Footer from '../components/Footer/Footer';

const LandingPage = () => {
    return (
        <>
            <Navbar />
            <HeroSection />
            <About />
            <TabsSection />
            <Services />
            <PricingPlans />
            <Footer />
        </>
    );
};

export default LandingPage;
